var _defs, _rect, _circle, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel1MeThumbsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2,.cls-4,.cls-5{fill:#fff;}.cls-2,.cls-3,.cls-4{stroke:#000;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-4{stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 97.97,
    cy: 202.28,
    r: 20.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.32,
    cy: 213.61,
    rx: 1.72,
    ry: 2.29,
    transform: "translate(-106.51 86.68) rotate(-34.74)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.82,
    cy: 207.11,
    rx: 1.72,
    ry: 2.29,
    transform: "translate(-100.4 93.22) rotate(-34.74)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.82,208.72a15,15,0,0,0-6.62,2.16,3.89,3.89,0,0,0-1.55,1.37c-.64,1.18-.08,2.66.75,3.72a6.41,6.41,0,0,0,5.69,2.58A4.37,4.37,0,0,0,89.88,214c-.18-1.47-1.22-3.08-.37-4.29a2.47,2.47,0,0,1,3.13-.41,27.2,27.2,0,0,1,2.76,2.07,6.46,6.46,0,0,0,9.87-7,4.14,4.14,0,0,0-3.18-3.23,7.12,7.12,0,0,0-3.52.92c-2.86,1.5-5.28,2.8-6.5,4.32A5.8,5.8,0,0,1,87.82,208.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104,202l7.51-6.47a6.19,6.19,0,0,1,2.27-1.46,2.19,2.19,0,0,1,2.44.72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.31,197.37a3.41,3.41,0,0,1,3.15.28c1,.53,1.79,1.28,2.77,1.77a6.17,6.17,0,0,0,6.74-.9c2-1.79,2.59-4.69,4.35-6.71a7.52,7.52,0,0,1,7.84-2.16c2.37.78,4.28,2.73,6.73,3.17,1.24.22,2.54,0,3.75.38a6.07,6.07,0,0,1,3.64,3.4,17.94,17.94,0,0,1,1.24,5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.58,424.6a54.61,54.61,0,0,0-9.74,6.62c-.74.63-1.52,1.44-1.37,2.38.21,1.31,2,1.68,3.33,1.73a130.1,130.1,0,0,0,17.21-.58,8,8,0,0,0,4-1.16,5.17,5.17,0,0,0,1.76-5,15.07,15.07,0,0,0-2.14-5.11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.65,425.69a71.82,71.82,0,0,0-11.58,8.44,5.5,5.5,0,0,0-1.66,2.07,1.8,1.8,0,0,0,.87,2.22,4.58,4.58,0,0,0,2.45.17l17.21-2c2.57-.29,5.35-.68,7.09-2.22a5.32,5.32,0,0,0,1.69-4.25,15.07,15.07,0,0,0-1.12-4.46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M99.87,323c3.36,35.65,7.23,65.83,14.72,101.19,4.7-.29,9.41-.58,14.12-.77l.83,2.32,15.07-.18c-1.3-37.19-2.13-69-5-106.14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.56,324.86a876.85,876.85,0,0,0,14.5,99.88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M141.85,264.07c-1.92-14.55-6.3-28.93-14.37-41.21a9.55,9.55,0,0,0-2.57-2.69c-4.83-3.29-8.84.43-12.63,3-2.26,1.53-4.32,4.37-7.37,3.85a3.37,3.37,0,0,0-3.8,3.08,87.64,87.64,0,0,1-4,19.85c-2.74,8.43-7.13,15.49-14,18.38a24.1,24.1,0,0,0-7.92,6.57,4.38,4.38,0,0,0-.54,4.17C75.94,282,80,281.71,83,280.6a36.34,36.34,0,0,0,21.47-23.84L100,284.52c-.53,5.37-3.82,28.31-1.15,38.18.37,1.38,20.71-1.64,31.07-2.46,2.63-.21,11.53.26,11.57.08,1.12-4.3.63-9.9.94-14.56C143.36,291.87,143.68,277.87,141.85,264.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.16,277.23l.7-3.22c.61-2.05,1.56-3.46,3.25-3.38l19.3,1a3.33,3.33,0,0,1,2.88,3.69l-.7,3.23C89,280.82,88,282,86.34,281.93l-19.3-1A3.34,3.34,0,0,1,64.16,277.23Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.79,236.38c-7.16,21.56-15.67,31.51-31,37.57a4,4,0,0,1-1-.45,9.43,9.43,0,0,0-3-.93c-1.46-.24-2.76-.09-3.43.84-.82,1.12-.12,2,.43,2.95h0a7,7,0,0,0-2.94,1.4,4,4,0,0,0-1.67,3.9c.44,1.73,2.34,2.62,4.06,3.08,5.89,1.55,12.57-.75,18.18-3.1s10.54-6.57,15-10.69c7.82-7.22,12.83-15.76,15.62-28.1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.25,250.19a32.4,32.4,0,0,0,10.53,7.89"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.4,250.28a20.07,20.07,0,0,0,6.92,5.73,57.74,57.74,0,0,1,1.1-13.82"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 81.18,
    cy: 269.36,
    rx: 2.87,
    ry: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel1MeThumbsBg);
export default __webpack_public_path__ + "static/media/Idea_Panel_1_Me_ThumbsBG.f850a817a739a383e99f2e896c049656.svg";
export { ForwardRef as ReactComponent };